// extracted by mini-css-extract-plugin
module.exports = {"small":"Avatar_small__N_nJ2","medium":"Avatar_medium__VaEH9","large":"Avatar_large__7IF_k"};